import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAutoSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"auto-size, automatic-size, page"} maskId="square-filled-radius-0-stroke-1-IconAutoSize"><path fillRule="evenodd" clipRule="evenodd" d="M20 2H4V22H20V2ZM5 11V3H19V21H13V11H5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAutoSize;
